/*
  Configure global store for academy application
*/
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
import logger from 'redux-logger'
import authentication, {authDefaultState} from './authentication/javascripts/reducers';
import teamsReducer from './shared/javascripts/reducers/teamsReducer';
import filterOptionsReducer from './reports/general/javascripts/reducers/filterOptionsReducer';
import userActivitiesReducer from './reports/general/javascripts/reducers/userActivitiesReducer';
import adminStatusesReducer from './admin/statuses/javascripts/reducers';
import { reduxTokenAuthReducer } from 'redux-token-auth';

const configureStore = (reactData) => {
  let middlewares = [thunk]
  
  const defaultState = {
    authentication: authDefaultState
  };

  // Add redux-logger if not production
  if(reactData.app_env !== 'production') { middlewares = [...middlewares, logger] }
  
  const rootReducer = combineReducers({
    authentication,
    reduxTokenAuth: reduxTokenAuthReducer,
    teams: teamsReducer,
    filterOptions: filterOptionsReducer,
    userActivityCounts: userActivitiesReducer,
    form: formReducer,
    adminStatuses: adminStatusesReducer
  })

  return createStore(
    rootReducer,
    defaultState,
    applyMiddleware(...middlewares)
  )
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/store.js